import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "sort-content"
};
var _hoisted_2 = {
  class: "item-sort"
};
var _hoisted_3 = {
  class: "left-div"
};
var _hoisted_4 = {
  class: "img-div"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "item-name"
};
var _hoisted_7 = {
  class: "right-div"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = ["onClick"];
import draggable from 'vuedraggable';
import { ref, toRefs, watch, onMounted } from 'vue';
import { getAppSort, sortApp } from '@/api/home.js';
import { MessagePlugin as message } from 'tdesign-vue-next';
export default {
  __name: 'AppSortDialog',
  props: /*@__PURE__*/_mergeModels({
    tabType: {
      type: String,
      default: 'teacher'
    }
  }, {
    "sortVisible": false,
    "sortVisibleModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['refresh'], ["update:sortVisible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var props = __props;
    var _toRefs = toRefs(props),
      tabType = _toRefs.tabType;
    var emit = __emit;
    var visible = _useModel(__props, 'sortVisible', false);

    /** 初始化相关 */
    var appDatas = ref([]);
    var getApp = function getApp() {
      getAppSort(tabType.value).then(function (res) {
        if (res.data.code === 0) {
          appDatas.value = res.data.data || [];
        }
      });
    };
    watch(function () {
      return visible.value;
    }, function (val) {
      if (val) getApp();
    }, {
      immediate: true,
      deep: true
    });

    /** 事件相关 */
    /**
     * 降序
     */
    var handleDown = function handleDown(item, index, isDisabled) {
      if (isDisabled) return;
      appDatas.value.splice(index, 1);
      appDatas.value.splice(index + 1, 0, item);
    };

    /**
     * 升序
     */
    var handleUp = function handleUp(item, index, isDisabled) {
      if (isDisabled) return;
      appDatas.value.splice(index, 1);
      appDatas.value.splice(index - 1, 0, item);
    };
    var onDragEnd = function onDragEnd() {
      console.log('拖拽结束', appDatas.value);
    };
    /**
     * 确认
     */
    var handleSure = function handleSure() {
      var data = appDatas.value.map(function (i, index) {
        return {
          appId: i.appId,
          sort: index + 1
        };
      });
      sortApp(tabType.value, data).then(function (res) {
        if (res.data.code === 0) {
          message.success('调整成功');
          emit('refresh');
          visible.value = false;
        }
      });
    };
    return function (_ctx, _cache) {
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        destroyOnClose: "",
        width: "432",
        class: "sort-dialog",
        onConfirm: handleSure
      }, {
        header: _withCtx(function () {
          return _toConsumableArray(_cache[2] || (_cache[2] = [_createElementVNode("div", {
            class: "sort-title"
          }, [_createTextVNode(" 应用顺序调整 "), _createElementVNode("span", {
            class: "sort-tips"
          }, "（长按应用可以拖动调整）")], -1)]));
        }),
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [!appDatas.value.length ? (_openBlock(), _createBlock(_component_t_loading, {
            key: 0,
            size: "small",
            class: "loading-div"
          })) : (_openBlock(), _createBlock(_unref(draggable), {
            key: 1,
            modelValue: appDatas.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return appDatas.value = $event;
            }),
            "item-key": "alias",
            class: "sort-list",
            onEnd: onDragEnd
          }, {
            item: _withCtx(function (_ref2) {
              var element = _ref2.element,
                index = _ref2.index;
              return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
                name: "move",
                class: "drag-icon"
              }), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
                src: element.icon,
                alt: "",
                class: "img-icon"
              }, null, 8, _hoisted_5)]), _createElementVNode("span", _hoisted_6, _toDisplayString(element.appName), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
                class: "icon",
                onClick: function onClick($event) {
                  return handleDown(element, index, index + 1 === appDatas.value.length);
                }
              }, [_createVNode(_component_svg_icon, {
                name: index + 1 === appDatas.value.length ? 'down-disabled' : 'down',
                class: _normalizeClass({
                  'sort-icon': true,
                  'disabled-icon': index + 1 === appDatas.value.length
                })
              }, null, 8, ["name", "class"])], 8, _hoisted_8), _createElementVNode("div", {
                class: "icon",
                onClick: function onClick($event) {
                  return handleUp(element, index, index === 0);
                }
              }, [_createVNode(_component_svg_icon, {
                name: index === 0 ? 'up-disabled' : 'up',
                class: _normalizeClass({
                  'sort-icon': true,
                  'disabled-icon': index === 0
                })
              }, null, 8, ["name", "class"])], 8, _hoisted_9)])])];
            }),
            _: 1
          }, 8, ["modelValue"]))])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};